import { graphql, useStaticQuery } from 'gatsby';
import React, { FC, useContext } from 'react';

import LoadingWrapper from '@ui/atoms/LoadingWrapper';

import useMemberInfo from '@hooks/useMemberInfo';

import { keysToCamel } from '@utils/butter';

import FlowContext from '@providers/FlowContextProvider';

import { IFlowStepProps } from '@folx-types/flow-steps';

import MemberAppointmentInfoStep, {
	IMemberAppointmentInfoStepPageContent,
} from './MemberAppointmentInfoStep.component';

interface IMemberAppointmentInfoStepPageProps extends IFlowStepProps {
	hideNavBack?: boolean;
}

const MemberAppointmentInfoStepPage: FC<IMemberAppointmentInfoStepPageProps> = ({
	path,
	stepKey,
	hideNavBack = false,
}) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "member-appointment-info-step" }) {
				page_header
				page_info
			}
		}
	`);

	const { memberInfo, loading } = useMemberInfo([], 'cache-first');

	const { handleNavNext, handleNavBack } = useContext(FlowContext);

	const refinedContent: IMemberAppointmentInfoStepPageContent = keysToCamel(
		pageContent
	) as IMemberAppointmentInfoStepPageContent;

	return (
		<LoadingWrapper loading={loading}>
			<MemberAppointmentInfoStep
				pageContent={refinedContent}
				path={path}
				stepKey={stepKey}
				handleNavNext={handleNavNext}
				handleNavBack={handleNavBack}
				member={memberInfo}
				hideNavBack={hideNavBack}
			/>
		</LoadingWrapper>
	);
};

export default MemberAppointmentInfoStepPage;
